import { Component } from "preact";
import style from "./style";
import DropList from "../../components/dropList";

const pagesizeDataArray = [10, 25, 50, 100];

export default class PaginationPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 10,
    };
    this.handleListClick = this.handleListClick.bind(this);
  }

  handleListClick(pageSize) {
    this.setState({ pageSize });
    this.props.paginationProps.changeSizePerPage(pageSize);
  }

  render({ paginationProps }) {
    return (
      <div className={style.mainWrapper}>
        <div>
          <span>Rows per page</span>
          <DropList
            dataArray={pagesizeDataArray}
            handleListClick={this.handleListClick}
            defaultValue={this.state.pageSize}
          />
        </div>
        <div>{paginationProps.components.pageList}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/paginationPanel/index.js